export default {
  config: {
    fps: false,
    text: false,
  },
};
